import { getSourceList } from "@/api/eldv2";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    integration: [],
    notIntegration: []
  },
  mutations: {
    SET_INTEGRATION(state, list) {
      state.integration = list;
    },
    SET_NOTINTEGRATION(state, list) {
      state.notIntegration = list;
    },
  },
  actions: {
    async getSourceList({ commit }, data) {
      await getSourceList(data).then(({ res }) => {
        const { code, data, message } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          return;
        }
        commit('SET_INTEGRATION', data.integration);
        commit('SET_NOTINTEGRATION', data.noIntegration);
      }).catch((e) => {
        console.error(e);
      });
    }
  },
}
